import { Tooltip } from 'antd';

const HighlightedCell = ({cellValue, tooltipText}) => {
    return (
        <Tooltip title={
            <div>
                <p>{tooltipText}</p>
            </div>
        } color="#001529">
            <span style={{color: "orange"}}>{typeof cellValue === 'function' ? cellValue() : cellValue}</span>
        </Tooltip>
    )
}

export default HighlightedCell;